import waitForDeferredResult from "./waitForDeferredResult"
import restClient from 'Shared/hooks/restClient'

export default async function deferredFetch(path, params) {
  return restClient.post(path, params)
    .then(({ data: { deferredResultId } }) =>
      waitForDeferredResult(deferredResultId)
    )
}
